import { RadioContainer, RadioInput, RadioLabel } from "./index.styled";

interface RadioInputProps {
  id: string;
  radioGroup: string;
  checked?: boolean;
  setChecked?: (value: boolean) => void;
  label: string;
  color?: string;
  value: any;
}

const RadioInputComponent: React.FC<RadioInputProps> = ({
  id,
  radioGroup,
  checked,
  setChecked,
  label,
  color = "black",
  value,
}) => {
  return (
    <RadioContainer htmlFor={id}>
      <RadioInput
        type="radio"
        id={id}
        name={radioGroup}
        color={color}
        checked={checked}
        value={value}
        onChange={() => setChecked && setChecked(!checked)}
      />
      <RadioLabel>{label}</RadioLabel>
    </RadioContainer>
  );
};

export default RadioInputComponent;
